import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ComplaintTypesActions } from './complaint-types.actions';
import { ComplaintTypeService } from '../../services/complaint-type.service';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class ComplaintTypesEffects {
  private actions$ = inject(Actions);
  private service = inject(ComplaintTypeService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComplaintTypesActions.loadComplaintTypes),
      switchMap(() =>
        this.service.getAll().pipe(
          map(data => ComplaintTypesActions.loadComplaintTypesSuccess({ data })),
          catchError(error => of(ComplaintTypesActions.loadComplaintTypesFailure({ error: error.message })))
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComplaintTypesActions.createComplaintType),
      mergeMap(({ data }) =>
        this.service.create(data).pipe(
          map(created => ComplaintTypesActions.createComplaintTypeSuccess({ data: created })),
          catchError(error => of(ComplaintTypesActions.createComplaintTypeFailure({ error: error.message })))
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComplaintTypesActions.updateComplaintType),
      mergeMap(({ id, data }) =>
        this.service.update(id, data).pipe(
          map(updated => ComplaintTypesActions.updateComplaintTypeSuccess({ data: updated })),
          catchError(error => of(ComplaintTypesActions.updateComplaintTypeFailure({ error: error.message })))
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComplaintTypesActions.deleteComplaintType),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => ComplaintTypesActions.deleteComplaintTypeSuccess({ id })),
          catchError(error => of(ComplaintTypesActions.deleteComplaintTypeFailure({ error: error.message })))
        )
      )
    )
  );
}
